import { render, staticRenderFns } from "./AccountSettingsAccount.vue?vue&type=template&id=042c8407"
import script from "./AccountSettingsAccount.vue?vue&type=script&lang=js"
export * from "./AccountSettingsAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports